// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"udvx7P","iconContainer":"KtyX3F","iconContainerCompleted":"_2kDmNt","icon":"_2xgL1F","preTitle":"_2Yhz2r"};